import { Box } from "@mui/material";
import HtmlEditor from "@entrilia/shared/components/html/HtmlEditor";

interface Props {
  initialContent: string;
  onChange: (htmlContent: string) => void;
}

const UserConsentContentEditor = ({ initialContent, onChange }: Props) => {
  return (
    <Box sx={{ bgcolor: "background.paper", height: "fit-content" }}>
      <HtmlEditor
        initialContent={initialContent}
        onChange={onChange}
        focusOnInit
        editorStyles={{ width: "47.5rem", maxHeight: "calc(100vh - 224px)" }}
      />
    </Box>
  );
};

export default UserConsentContentEditor;
